export default __webpack_public_path__ + "afc2797c1ae715086330e1d3b5d74555.png";